export { default as SectionsMenu } from './SectionsMenu';
export type {
    SectionsMenuProps,
    Menu as SectionMenu,
    SectionsMenuClasses
} from './SectionsMenu.types';
